import { styled, css } from "@mui/system";

export const Styles = styled("div")(
    ({ theme, orderOption }) => css`
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 20px;
    
    .switch-container {
      width: 360px; /* Increased width for 3 options */
      border-radius: 5px;
      border: 1px solid #3f78e0;
      padding: 15px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      position: relative;
      overflow: hidden;
      cursor: pointer;
      font-size: 14px;
      font-weight: 600;
      
      .service, .offer, .domain {
        flex: 1;
        text-align: center;
        z-index: 2;
        padding: 5px 0;
      }
      
      .service {
        color: ${orderOption === "service" ? "white" : "black"};
      }
      .offer {
        color: ${orderOption === "offer" ? "white" : "black"};
      }
      .domain {
        color: ${orderOption === "domain" ? "white" : "black"};
      }
      
      &::after {
        position: absolute;
        z-index: 1;
        content: "";
        top: 0;
        height: 100%;
        width: 33.33%; /* Equal width for 3 options */
        background-color: #3f78e0;
        transition: left 0.3s;
        
        /* Position based on selected option */
        ${orderOption === "service" && "left: 0;"}
        ${orderOption === "offer" && "left: 33.33%;"}
        ${orderOption === "domain" && "left: 66.66%;"}
      }
    }
  `
);